import { ref, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useAuthStore } from "@/store/auth.store";
import ToolsService from "@/services/ToolsService";
import { useDisplay, useTheme } from "vuetify/lib/framework.mjs";

export default class AppLayoutViewModel {
  private toolsService: ToolsService;
  private route = useRoute(); // Acceso a la ruta actual
  private router = useRouter();
  private store = useAuthStore();
  private display = useDisplay();
  private theme = useTheme();
  public appName = process.env.VUE_APP_APP_NAME || "";
  public options = [
    { title: "Dashboard", icon: "mdi-chart-bar", route: "/app/home" },
    {
      title: "Movimientos",
      icon: "mdi-swap-horizontal-bold",
      route: "/app/transactions",
    },
    {
      title: "Productos / Servicios",
      icon: "mdi-apps",
      route: "/app/products",
    },
    { title: "Configuración", icon: "mdi-cog", route: "/app/settings" },
  ];
  public isLargeScreen = computed(() => this.display.mdAndUp);

  public drawer = ref(this.isLargeScreen.value);

  // Datos del usuario desde el store
  public user = computed(() => this.store.getUserData);

  // Mostrar el nombre del usuario o un valor por defecto
  public userName = computed(() => this.user.value?.nom || "Usuario");

  // Mostrar el correo del usuario o vacío
  public userEmail = computed(() => this.user.value?.email || "");

  public userInitial = computed(() => {
    const name = this.user.value?.nom || "Usuario";
    return this.toolsService.userInitial(name);
  });

  public isDarkMode = computed({
    get: () => this.theme.global.name.value === "dark",
    set: (value: string) => {
      //console.log(value);
      const newTheme =
        this.theme.global.name.value === "dark" ? "light" : "dark";
      this.theme.global.name.value = newTheme;

      // Guardar el tema seleccionado en localStorage
      localStorage.setItem("theme", newTheme);
    },
  });
  constructor() {
    this.toolsService = new ToolsService();

    this.setupInactivityListener();

    const systemPrefersDark = window.matchMedia(
      "(prefers-color-scheme: dark)"
    ).matches;
    const defaultTheme = systemPrefersDark ? "dark" : "light";

    // Crear una referencia para almacenar el tema
    const savedTheme = localStorage.getItem("theme") || defaultTheme;

    if (savedTheme) {
      this.theme.global.name.value = savedTheme;
    }
  }
  isActiveRoute(route: string): boolean {
    return this.route.path === route;
  }
  /*   toggleTheme = () => {
    const newTheme = this.theme.global.name.value === "dark" ? "light" : "dark";
    this.theme.global.name.value = newTheme;

    // Guardar el tema seleccionado en localStorage
    localStorage.setItem("theme", newTheme);
  };
 */
  hideWords(word: string): string {
    return this.toolsService.hideWords(word);
  }

  hideEmailCharacters(word: string): string {
    return this.toolsService.hideEmailCharacters(word);
  }

  toggleDrawer() {
    this.drawer.value = !this.drawer.value;
  }

  navigateTo(route: string) {
    this.router.push(route);
  }

  private setupInactivityListener(): void {
    // Función para manejar las interacciones del usuario
    const updateInteraction = (event: Event) => {
      if (!this.store.updateLastInteraction()) {
        this.logout();
      }
    };

    // Lista de eventos que queremos escuchar
    const events = ["click", "mousemove", "keydown", "scroll"];

    // Agregar listeners para los eventos
    events.forEach((event) =>
      document.addEventListener(event, updateInteraction)
    );

    // Limpiar los listeners cuando la página se cierre
    window.addEventListener("beforeunload", () => {
      events.forEach((event) =>
        document.removeEventListener(event, updateInteraction)
      );
    });
  }
  public logout(): void {
    this.store.logoutUser();
    this.router.push("/login");
  }
}
